import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from "@mui/material";
import classNames from "classnames";
import { useIntl } from "react-intl";
import useLoginSignupStyles from "./styles";
import I18nKey from "translations/I18nKey";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import { apiClient } from "api";
import { SetStateAction, useState } from "react";
import SimpleButton from "components/SimpleButton";
import MobileTextField from "components/MobileTextField";
import { countries } from "utils/utils";

interface ConfirmVerifyonLoginInterface {
  userName: string;
  setConfirmUserName: React.Dispatch<SetStateAction<string>>;
  setIsOTPSend: React.Dispatch<SetStateAction<boolean>>;
}

export const ConfirmVerifyonLogin: React.FC<ConfirmVerifyonLoginInterface> = ({
  userName,
  setConfirmUserName,
  setIsOTPSend,
}) => {
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width : 768px)");
  const classes = useLoginSignupStyles();
  const [inputModal, setInputModal] = useState<string>("");
  const [emailInputModal, setEmailInputModal] = useState<string>("");
  const [phoneNumberInputModal, setPhoneNumberInputModal] =
    useState<string>("");
  const [verifyAccErr, setVerifyAccErr] = useState<string>("");
  const [countryCode, setCountryCode] = useState<string>("US");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const checkInputType = (inputValue: string) => {
    const containsAtSymbol = inputValue.includes("@");
    const containsDigits = /^\d+$/.test(inputValue);
    const containsCharacters = /[a-zA-Z]/.test(inputValue);
    if (containsDigits && !containsCharacters && !containsAtSymbol) {
      setPhoneNumberInputModal(inputValue);
      setEmailInputModal("");
      setInputModal("");
    } else {
      setEmailInputModal(inputValue);
      setPhoneNumberInputModal("");
      setInputModal("");
    }
  };

  const handleEmailChangeModal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailInputModal(e.target.value);
    if (verifyAccErr?.length > 0) setVerifyAccErr("");
    // checkInputType(e.target.value);
  };

  const handlePhoneNumberChangeModal = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhoneNumberInputModal(e.target.value);
    if (verifyAccErr?.length > 0) setVerifyAccErr("");
    checkInputType(e.target.value);
  };

  const handleChangeModal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputModal(e.target.value);
    if (verifyAccErr.length > 0) setVerifyAccErr("");
    checkInputType(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleResendCode = async () => {
    setIsLoading(true);
    setConfirmUserName(emailInputModal);
    await apiClient
      .resendOTP(emailInputModal)
      .then((res) => {
        if (res?.data.data) {
          setVerifyAccErr("");
          setIsOTPSend(true);
        } else if (res.config.data.data.errors) {
          setVerifyAccErr(res.config.data.data.errors);
        }
      })
      .catch((err) => {
        setVerifyAccErr(err?.response?.data?.errors);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className={classNames(classes.signupConfirmMsgContainer)}>
            <Typography className={classNames(classes.signupConfirmMsg)}>
              {intl.formatMessage(
                {
                  id: I18nKey.VERIFY_USER_LOGIN_MSG,
                },
                {
                  userVariable: userName,
                }
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {/*
          WILL BE USED AFTER PHONE INTEGRATION GETS COMPLETED (CHINESE) */}
          {phoneNumberInputModal && (
            <>
              <Box sx={{ display: "flex" }}>
                <FormControl sx={{ marginRight: "10px !important" }}>
                  <Select
                    value={countryCode}
                    onChange={(e) => {
                      setCountryCode(e.target.value);
                    }}
                    placeholder={intl.formatMessage({
                      id: I18nKey.CODE,
                    })}
                    name="country_code"
                    size="medium"
                    sx={{
                      width: "50px",
                      background: "#fff",
                    }}
                  >
                    {countries.map((item) => (
                      <MenuItem key={item.code} value={item.code}>
                        {item.code + "(" + item.phone + ")"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <MobileTextField
                  placeholder="Mobile Number"
                  value={phoneNumberInputModal}
                  width="100%"
                  onChange={handlePhoneNumberChangeModal}
                  autoFocus
                  sx={{ backgroundColor: "white", borderRadius: "10px" }}
                  onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                    handleKeyDown(e)
                  }
                  err={verifyAccErr}
                />
              </Box>
            </>
          )}
          {emailInputModal && (
            <MobileTextField
              placeholder={intl.formatMessage({
                id: I18nKey.EMAIL,
              })}
              value={emailInputModal}
              onChange={handleEmailChangeModal}
              autoFocus
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
              err={verifyAccErr}
              className={classNames(classes.emailPlaceHolder)}
            />
          )}
          {/* 
           WILL BE USED AFTER PHONE INTEGRATION GETS COMPLETED (CHINESE) */}
          {!phoneNumberInputModal && !emailInputModal && (
            <MobileTextField
              placeholder="Mobile Number or Email"
              value={inputModal}
              onChange={handleChangeModal}
              autoFocus
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
              err={verifyAccErr}
              width="100%"
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <Box className={classNames(classes.verifyBtnsContainer)}>
            <SimpleButton
              text={intl.formatMessage({
                id: I18nKey.VERIFY_ACCOUNT,
              })}
              className="verifyBtn"
              primary
              loading={isLoading}
              onClick={handleResendCode}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          {verifyAccErr && (
            <AlertPopupMobile
              loading={isLoading}
              alertMsg={verifyAccErr}
              className={classNames(classes.alertPopupMobileconfirm, {
                mobile: isMobile,
                default: !isMobile,
              })}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};
